module.exports = __webpack_public_path__ + "static/media/logosaving.0dc6f952.jpeg";